import React from 'react';
import { Paper, Stack, Tab, Tabs } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { SectionHeader } from './ragAdminUtils';
import RagOverviewPanel from './RagOverviewPanel';
import RagPipelineProfilesPanel from './RagPipelineProfilesPanel';
import ProductMappingsPanel from './ProductMappingsPanel';
import GtmRagResolutionPanel from './GtmRagResolutionPanel';
import RagCoverageReportPanel from './RagCoverageReportPanel';
import RagConfigTables from './RagConfigTables';
import LocalFilesPanel from './LocalFilesPanel';
import { useNavigate, useParams } from 'react-router-dom';
import { ADMIN_URL_TOOLBOX_CONFIG } from '../../PageStructure/admin-values';

const RAG_TABS = [
  'overview',
  'pipeline-profiles',
  'product-mappings',
  'gtm-resolution',
  'local-files',
  'coverage',
  'config',
]

type RagTab = typeof RAG_TABS[number];

const RagAdminView: React.FC = () => {
  // const [tab, setTab] = React.useState<RagTab>('overview');
  const navigate = useNavigate();
  const { tab2 } = useParams();
  const tab = RAG_TABS.includes(tab2) ? tab2 : RAG_TABS[0];
  const setTab = (tabName: string): void => navigate(`${ADMIN_URL_TOOLBOX_CONFIG}/ai/rag/${tabName}`);

  return (
    <Stack spacing={2}>
      <SectionHeader
        icon={<AccountTreeIcon color="primary" />}
        title="RAG Pipeline Administration"
        description="Manage DRIFT/RAG blue-green profiles, active/ingest slots, Cisco product mappings, derived GTM RAG resolution, local file conversion, product coverage, and DB-backed AI configuration."
      />

      <Paper variant="outlined" sx={{ p: 2 }}>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
        >
          <Tab value="overview" label="Overview" />
          <Tab value="pipeline-profiles" label="Pipeline Profiles / Slots" />
          <Tab value="product-mappings" label="Product Mappings" />
          <Tab value="gtm-resolution" label="GTM Resolution" />
          <Tab
            value="local-files"
            icon={<AttachFileIcon fontSize="small" />}
            iconPosition="start"
            label="Local Files"
          />
          <Tab value="coverage" label="Coverage" />
          <Tab value="config" label="Config Tables" />
        </Tabs>

        {tab === 'overview' ? <RagOverviewPanel /> : null}
        {tab === 'pipeline-profiles' ? <RagPipelineProfilesPanel /> : null}
        {tab === 'product-mappings' ? <ProductMappingsPanel /> : null}
        {tab === 'gtm-resolution' ? <GtmRagResolutionPanel /> : null}
        {tab === 'local-files' ? <LocalFilesPanel /> : null}
        {tab === 'coverage' ? <RagCoverageReportPanel /> : null}
        {tab === 'config' ? <RagConfigTables /> : null}
      </Paper>
    </Stack>
  );
};

export default RagAdminView;